// Icons
import Check from '@/assets/svg/circle-check-outline.svg'

function Benefits({ className, wording, hideSeparator = false }) {
  return (
    <section className={`flex flex-wrap gap-10 ${className}`}>
      {wording?.map((W, i) => (
        <div
          key={i}
          className="flex items-center justify-center md:justify-auto text-16 sm:text-base"
        >
          <Check className="mr-10 flex-shrink-0" />
          <p>{W}</p>
          {i < wording?.length - 1 && !hideSeparator ? (
            <div className="sm:pl-10 h-12 w-px opacity-20 sm:border-r border-current" />
          ) : null}
        </div>
      ))}
    </section>
  )
}

export default Benefits
